var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Editor',{attrs:{"file-id":_vm.fileid,"relative-path":_vm.filename,"active":_vm.active,"autofocus":_vm.autofocus,"share-token":_vm.shareToken,"mime":_vm.mime,"show-outline-outside":_vm.showOutlineOutside}})
}
var staticRenderFns = []

export { render, staticRenderFns }